<div class="card mt-2 h-100 p-3 pb-5 d-flex flex-column gap-3 profiles">
  <div class="py-1 title">Profile Settings</div>
  <app-profile-general></app-profile-general>
</div>
